import { ProjectRenderer } from './ProjectRenderer';
import { GLTFExporter } from 'three/examples/jsm/exporters/GLTFExporter.js';
import { formatExactDate } from '@/utils/utilities';
import fileDownload from 'js-file-download';

export enum ExportType {
	GLTF = 'gltf',
}

export class Exporter {
	private gltfExporter = new GLTFExporter();

	constructor(private renderer: ProjectRenderer) {}

	exportCollection(type: ExportType) {
		switch (type) {
			case ExportType.GLTF:
				this.exportGLTF();
				break;

			default:
				throw new Error('UNKNOWN_EXPORT_TYPE');
		}
	}

	private exportGLTF() {
		this.gltfExporter.parse(
			this.renderer.collection,
			(glb) => {
				const date = formatExactDate(new Date());

				fileDownload(glb as ArrayBuffer, `Konfiguracja ${date}.glb`);
			},
			(error) => {
				console.error('ERROR_EXPORT_GLB:', error);
			},
			{
				binary: true,
			}
		);
	}
}
